import './index.less';

import { Modal } from 'antd';
import { ModalProps } from 'antd/es/modal';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import { isMobile } from '@/utils/ua';

interface IProps {
  title: ReactNode;
  visible: boolean;
  onOK?: () => void;
  onCancel?: () => void;
  children?: ReactNode;
  ByFooter?: ReactNode | null;
  width?: number;
  modalProps?: ModalProps;
  forceRender?: boolean;
  closeIconHandler?: () => void;
  showCloseIcon?: boolean;
  newStyle?: boolean;
  classNames?: string;
}
/*
  title:模态框头部  如果不需要标题文字，传null
  visible:模态框显示隐藏按钮
  onOK:点击确认回调函数
  onCancel:点击取消回调函数
  children:模态框中显示内容
  ByFooter:底部操作按钮,操作按钮必须有父元素div标签
  width:宽度
*/
const CanCelIcon = () => {
  return (
    <svg
      className="by-modal-close-icon"
      width="10"
      height="10"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6918 13.7756L7.00016 8.0839L1.30854 13.7756C1.11485 13.9692 0.832577 14.0448 0.568053 13.9738C0.303529 13.9029 0.0969383 13.6962 0.0261026 13.4317C-0.0447331 13.1671 0.0309475 12.8849 0.224636 12.6913L5.91626 6.99999L0.224636 1.30872C-0.0747805 1.00941 -0.0748663 0.524038 0.224444 0.22462C0.523755 -0.0747984 1.00912 -0.0748842 1.30854 0.224428L7.00016 5.91608L12.6918 0.224428C12.8855 0.0308755 13.1677 -0.0446424 13.4322 0.0263214C13.6966 0.0972852 13.9032 0.30395 13.9739 0.568466C14.0447 0.832983 13.969 1.11516 13.7753 1.30872L8.08445 6.99999L13.7753 12.6913C13.969 12.8848 14.0447 13.167 13.9739 13.4315C13.9032 13.696 13.6966 13.9027 13.4322 13.9737C13.1677 14.0446 12.8855 13.9691 12.6918 13.7756Z"
        fill="#ADB1B8"
      />
    </svg>
  );
};

const ByModal: FC<IProps> = (props: IProps) => {
  return (
    <>
      <Modal
        className={classNames('byModal', props.classNames || '', {
          byModalH5: isMobile(),
          byModalNew: props.newStyle,
        })}
        title={props.title}
        visible={props.visible}
        onOk={props.onOK}
        onCancel={props.onCancel}
        maskClosable={false}
        footer={props.ByFooter ? props.ByFooter : null}
        closeIcon={
          props.title !== null || props.showCloseIcon ? (
            <CanCelIcon></CanCelIcon>
          ) : null
        }
        width={props.width ? props.width : 480}
        closable={props.title === null ? false : true}
        {...(props.modalProps || {})}
      >
        {props.children}
      </Modal>
    </>
  );
};
export default ByModal;
